/** Stored hopper size only. Never invent capacity from remaining × percent. */

export function hopperAddHeadroom(capacityLbs, remainingLbs) {
  const capacity = Number(capacityLbs);
  if (!Number.isFinite(capacity) || capacity <= 0) return null;
  const remaining = Number(remainingLbs);
  const left = Number.isFinite(remaining) ? Math.max(0, remaining) : 0;
  return Math.max(0, Math.round(capacity) - Math.round(left));
}

export function hopperOverfillMessage(capacityLbs, headroom) {
  const cap = Math.round(capacityLbs);
  if (headroom <= 0) return `Hopper is full (${cap} lbs).`;
  return `Hopper holds ${cap} lbs (${headroom} lbs free).`;
}

export function hopperOverfillWarning({ amountLbs, capacityLbs, remainingLbs } = {}) {
  const amount = Number(amountLbs);
  if (!Number.isFinite(amount) || amount <= 0) return null;
  const headroom = hopperAddHeadroom(capacityLbs, remainingLbs);
  if (headroom == null) return null;
  if (amount <= headroom) return null;
  return hopperOverfillMessage(Number(capacityLbs), headroom);
}
